import type { Template } from "@/types";

export const PO_07_H3_V4: Template[] = [
{
    id: "po-07-h3v4-01",
    name: "PO 01 - H3V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h3_v4_01.png",
    size: [1136, 854],
    style: {},
        slots: [
            { id: "1", x: 40, y: 147, width: 489, height: 362, rotation: 0, imageRotation: 0 },
            { id: "2", x: 40, y: 517, width: 241, height: 189, rotation: 0, imageRotation: 0 },
            { id: "3", x: 289, y: 517, width: 240, height: 189, rotation: 0, imageRotation: 0 },
            { id: "4", x: 671, y: 147, width: 177, height: 276, rotation: 0, imageRotation: 0 },
            { id: "5", x: 671, y: 431, width: 177, height: 276, rotation: 0, imageRotation: 0 },
            { id: "6", x: 856, y: 147, width: 177, height: 276, rotation: 0, imageRotation: 0 },
            { id: "7", x: 856, y: 431, width: 177, height: 276, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-07-h3v4-02",
    name: "PO 02 - H3V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h3_v4_02.png",
    size: [1136, 854],
    style: {},
    slots: [     
        { id: "1", x: 56, y: 173, width: 182, height: 164, rotation: 0, imageRotation: 0 },
        { id: "2", x: 56, y: 345, width: 182, height: 164, rotation: 0, imageRotation: 0 },
        { id: "3", x: 56, y: 517, width: 182, height: 164, rotation: 0, imageRotation: 0 },
        { id: "4", x: 246, y: 173, width: 279, height: 508, rotation: 0, imageRotation: 0 },
        { id: "5", x: 613, y: 173, width: 308, height: 508, rotation: 0, imageRotation: 0 },
        { id: "6", x: 929, y: 173, width: 152, height: 251, rotation: 0, imageRotation: 0 },
        { id: "7", x: 929, y: 432, width: 152, height: 250, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h3v4-03",
    name: "PO 03 - H3V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h3_v4_03.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 32, y: 135, width: 510, height: 378, rotation: 0, imageRotation: 0 },      
        { id: "2", x: 32, y: 521, width: 251, height: 198, rotation: 0, imageRotation: 0 },
        { id: "3", x: 291, y: 521, width: 251, height: 198, rotation: 0, imageRotation: 0 },
        { id: "4", x: 593, y: 135, width: 380, height: 584, rotation: 0, imageRotation: 0 },
        { id: "5", x: 981, y: 135, width: 122, height: 190, rotation: 0, imageRotation: 0 },
        { id: "6", x: 981, y: 333, width: 122, height: 189, rotation: 0, imageRotation: 0 },
        { id: "7", x: 981, y: 530, width: 122, height: 189, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h3v4-04",
    name: "PO 04 - H3V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h3_v4_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 133, y: 81, width: 301, height: 228, rotation: 0, imageRotation: 0 },
        { id: "2", x: 133, y: 317, width: 301, height: 228, rotation: 0, imageRotation: 0 },
        { id: "3", x: 133, y: 553, width: 301, height: 228, rotation: 0, imageRotation: 0 },
        { id: "4", x: 637, y: 81, width: 212, height: 346, rotation: 0, imageRotation: 0 },
        { id: "5", x: 637, y: 435, width: 212, height: 346, rotation: 0, imageRotation: 0 },
        { id: "6", x: 857, y: 81, width: 211, height: 346, rotation: 0, imageRotation: 0 },
        { id: "7", x: 857, y: 435, width: 211, height: 346, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h3v4-05",
    name: "PO 05 - H3V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h3_v4_05.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 52, y: 154, width: 463, height: 360, rotation: 0, imageRotation: 0 },
        { id: "2", x: 52, y: 522, width: 228, height: 178, rotation: 0, imageRotation: 0 },
        { id: "3", x: 288, y: 522, width: 227, height: 178, rotation: 0, imageRotation: 0 },
        { id: "4", x: 685, y: 154, width: 163, height: 270, rotation: 0, imageRotation: 0 },
        { id: "5", x: 685, y: 432, width: 163, height: 269, rotation: 0, imageRotation: 0 },
        { id: "6", x: 856, y: 154, width: 163, height: 270, rotation: 0, imageRotation: 0 },
        { id: "7", x: 856, y: 432, width: 163, height: 269, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h3v4-06",
    name: "PO 06 - H3V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h3_v4_06.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 79, y: 80, width: 410, height: 309, rotation: 0, imageRotation: 0 },
        { id: "2", x: 79, y: 397, width: 201, height: 147, rotation: 0, imageRotation: 0 },
        { id: "3", x: 288, y: 397, width: 201, height: 147, rotation: 0, imageRotation: 0 },
        { id: "4", x: 79, y: 552, width: 132, height: 222, rotation: 0, imageRotation: 0 },
        { id: "5", x: 219, y: 552, width: 131, height: 222, rotation: 0, imageRotation: 0 },
        { id: "6", x: 358, y: 552, width: 131, height: 222, rotation: 0, imageRotation: 0 },
        { id: "7", x: 647, y: 80, width: 410, height: 693, rotation: 0, imageRotation: 0 },         
    ],
},

{
    id: "po-07-h3v4-07",
    name: "PO 07 - H3V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h3_v4_07.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 79, y: 80, width: 202, height: 147, rotation: 0, imageRotation: 0 },
        { id: "2", x: 289, y: 80, width: 201, height: 147, rotation: 0, imageRotation: 0 },
        { id: "3", x: 79, y: 235, width: 410, height: 309, rotation: 0, imageRotation: 0 },       
        { id: "4", x: 79, y: 552, width: 132, height: 222, rotation: 0, imageRotation: 0 },
        { id: "5", x: 219, y: 552, width: 131, height: 222, rotation: 0, imageRotation: 0 },
        { id: "6", x: 358, y: 552, width: 131, height: 222, rotation: 0, imageRotation: 0 },
        { id: "7", x: 647, y: 80, width: 410, height: 693, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h3v4-08",
    name: "PO 08 - H3V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h3_v4_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 201, width: 564, height: 450, rotation: 0, imageRotation: 0 },
        { id: "2", x: 572, y: 423, width: 135, height: 228, rotation: 0, imageRotation: 0 },
        { id: "3", x: 715, y: 423, width: 135, height: 228, rotation: 0, imageRotation: 0 },
        { id: "4", x: 858, y: 423, width: 135, height: 228, rotation: 0, imageRotation: 0 },
        { id: "5", x: 1001, y: 423, width: 135, height: 228, rotation: 0, imageRotation: 0 },
        { id: "6", x: 572, y: 201, width: 278, height: 214, rotation: 0, imageRotation: 0 },
        { id: "7", x: 858, y: 201, width: 278, height: 214, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h3v4-09",
    name: "PO 09 - H3V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h3_v4_09.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 219, width: 237, height: 416, rotation: 0, imageRotation: 0 },
        { id: "2", x: 245, y: 219, width: 156, height: 134, rotation: 0, imageRotation: 0 },
        { id: "3", x: 245, y: 361, width: 156, height: 133, rotation: 0, imageRotation: 0 },
        { id: "4", x: 245, y: 502, width: 156, height: 133, rotation: 0, imageRotation: 0 },
        { id: "5", x: 409, y: 219, width: 237, height: 416, rotation: 0, imageRotation: 0 },
        { id: "6", x: 654, y: 219, width: 237, height: 416, rotation: 0, imageRotation: 0 },
        { id: "7", x: 899, y: 219, width: 237, height: 416, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h3v4-10",
    name: "PO 10 - H3V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h3_v4_10.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 219, width: 237, height: 416, rotation: 0, imageRotation: 0 },
        { id: "2", x: 245, y: 219, width: 237, height: 416, rotation: 0, imageRotation: 0 },
        { id: "3", x: 490, y: 219, width: 237, height: 416, rotation: 0, imageRotation: 0 },
        { id: "4", x: 735, y: 219, width: 236, height: 416, rotation: 0, imageRotation: 0 },
        { id: "5", x: 979, y: 219, width: 157, height: 134, rotation: 0, imageRotation: 0 },
        { id: "6", x: 979, y: 361, width: 157, height: 133, rotation: 0, imageRotation: 0 },
        { id: "7", x: 979, y: 502, width: 157, height: 133, rotation: 0, imageRotation: 0 }
    ],
}
];